import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/70">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-2 lg:grid-cols-4 md:px-6">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-2-line text-xl"></i>
            </span>
            <span className="font-heading text-lg text-foreground-950">天天漫画网</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            长期连载漫画库，稳定更新不断更。长篇神作、持续连载精品一网打尽，追更神器在手，轻松追更每一天。
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-sm font-bold text-foreground-950">栏目导航</h4>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            <li><Link to="/" className="transition-colors hover:text-primary-600">首页</Link></li>
            <li><Link to="/series" className="transition-colors hover:text-primary-600">全部连载</Link></li>
            <li><Link to="/about" className="transition-colors hover:text-primary-600">关于我们</Link></li>
            <li><Link to="/contact" className="transition-colors hover:text-primary-600">联系我们</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-sm font-bold text-foreground-950">热门题材</h4>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            <li><Link to="/series?genre=热血" className="transition-colors hover:text-primary-600">热血长篇</Link></li>
            <li><Link to="/series?genre=科幻" className="transition-colors hover:text-primary-600">科幻巨作</Link></li>
            <li><Link to="/series?genre=奇幻" className="transition-colors hover:text-primary-600">奇幻史诗</Link></li>
            <li><Link to="/series?genre=日常" className="transition-colors hover:text-primary-600">治愈日常</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-sm font-bold text-foreground-950">联系与支持</h4>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            <li className="flex items-center gap-2"><i className="ri-mail-line text-primary-600"></i>hello@tiantianmh.com</li>
            <li className="flex items-center gap-2"><i className="ri-wechat-line text-primary-600"></i>天天漫画网</li>
            <li className="flex items-center gap-2"><i className="ri-time-line text-primary-600"></i>每日 9:00 – 22:00</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 天天漫画网 · 长期连载漫画平台</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-primary-500"></i>
            稳定更新，陪伴每一个追更的你
          </p>
        </div>
      </div>
    </footer>
  );
}